import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'

import Resume from '../../../../assets/Maxim Kapelina - Resume 2026.pdf'

const AboutSummary = () => {
    const aboutSummary1 = "I am a Computer Science graduate of the University of Maryland with hands-on experience across application development and applied artificial intelligence. My work centers on Artificial Intelligence, Machine Learning, and full-stack Software Engineering, grounded in a strong foundation in core Computer Science principles."
    const aboutSummary2 = "Beyond writing code, I lead teams and solve problems creatively. I have managed development teams, served as a Chief Technology Officer, and coordinated cross-functional projects, always pairing technical depth with a strategic, business-minded approach to delivering real value."
    const aboutSummary3 = "Outside of my professional work, I am a FIDE-rated chess player who has competed in national and international tournaments, a lifelong piano player, and an active investor who manages my own portfolio. I also stay active through golf, pickleball, and swimming."

    return (
        <section className='text-white bg-primary mb-0'>
            <Container>
                <h2 className='text-uppercase text-center text-secondary'>About Me</h2>
                <hr className='star-dark mb-5'/>
                <Row>
                    <Col lg={4} className='ms-auto'>
                        <p className='lead text-secondary'>{aboutSummary1}</p>
                    </Col>
                    <Col lg={4} className='me-auto'>
                        <p className='lead text-secondary'>{aboutSummary2}</p>
                    </Col>
                    <Col lg={4} className='me-auto'>
                        <p className='lead text-secondary'>{aboutSummary3}</p>
                    </Col>
                </Row>
                <div className='text-center mt-4'>
                    <a href={Resume} download='Maxim_Kapelina-Resume.pdf'>
                        <Button className='border btn-xl'>
                            <i className='fa fa-download me-2'/>
                            <span>My Resume</span>
                        </Button>
                    </a>
                </div>
            </Container>
        </section>
    )
}


export default AboutSummary;
